import { Button } from "@/atoms"
import { PlayCircleOutlined } from "@/icons"

import type { TestPackageRegistryButtonProps } from "."

// Tests the form as it stands. A saved entry left with an empty secret is tested with its
// stored secret, so a row can be tested without re-entering the credential.
export const TestPackageRegistryButton = (
  props: TestPackageRegistryButtonProps
) => {
  const { size, form, t, registryApi } = props
  const tKey = props.tKey || "general.test"

  const onClick = async () => {
    try {
      await form.validateFields()
    } catch {
      return // the invalid fields show their errors inline
    }

    await registryApi.onTest(form.getFieldsValue(true))
  }

  return (
    <Button
      size={size}
      icon={<PlayCircleOutlined />}
      type="default"
      disabled={registryApi.isTesting || registryApi.isPending}
      onClick={onClick}
    >
      {t(tKey)}
    </Button>
  )
}
